export default function BookingStayTabs({ activeTab = "booking", onChange, checkoutDisabled = false, errorTabs = {} }) {
  const tabs = [
    { value: "booking", label: "Prenotazione" },
    { value: "services", label: "Servizi" },
    { value: "checkout", label: "Check Out", disabled: checkoutDisabled },
  ];
  return (
    <div className="booking_stay_tabs" role="tablist" aria-label="Gestione soggiorno">
      {tabs.map((tab) => {
        const hasError = Boolean(errorTabs?.[tab.value]);
        return (
        <button
          key={tab.value}
          type="button"
          className={`booking_stay_tab${activeTab === tab.value ? " is_active" : ""}${hasError ? " is_error" : ""}`}
          data-stay-tab={tab.value}
          onClick={() => onChange?.(tab.value)}
          disabled={tab.disabled}
          role="tab"
          aria-selected={activeTab === tab.value}
          aria-invalid={hasError ? "true" : undefined}
        >
          <span className="booking_stay_tab_dot" aria-hidden="true" />
          <span>{tab.label}</span>
        </button>
        );
      })}
    </div>
  );
}
